<template>
    <div class="c-tr">
        <div class="c-td">
            <ui-checkbox-input
                name="all-bags"
                :tooltip="checkboxTooltip"
                :tooltip-icon="false"
                :disabled="!isSelectable"
                :value="selectedPackageIds.includes(bag.package_id)"
                @change="togglePackageInMode(bag.package_id)"
            />
        </div>
        <div class="c-td">
            <fraction-label :fraction="fraction" />
        </div>
        <div class="c-td">
            <span
                class="status w-100"
                :class="{ 'is-success': isOpen, 'is-unavailable': !isOpen }"
                v-text="isOpen ? 'Otwarty' : 'Zamknięty'"
            />
        </div>
        <div class="c-td">
            <span v-text="'ID worka: '" class="d-md-none" />
            <strong v-text="bag.package_id" />
        </div>
        <div class="c-td text-center">
            <div v-text="'Numer plomby:'" class="d-md-none" />
            <span
                v-html="$options.sealNumber(bag.seal_number, shouldHighlightSealPrefix)"
                style="word-break: break-all;"
            /><br />
            <div class="d-md-none">
                Operator:
                <a-icon
                    icon="Info"
                    width="16"
                    height="16"
                    style="position: relative; top: 2px"
                    v-tooltip="$options.operatorTooltip"
                />
            </div>
            {{ operatorName }}
        </div>
        <div class="c-td text-center">
            <strong v-text="'Wartość worka: '" class="d-md-none" /><strong v-text="total" /><br />
            <span v-text="'Liczba opakowań: '" class="d-md-none" />({{ quantity }}&nbsp;szt.)
        </div>
        <div class="c-td">
            <the-btn
                v-text="isOpen ? 'Zamknij worek' : 'Zmień plombę'"
                class="btn-sm w-100"
                :class="{ 'btn-primary': isOpen, 'btn-gray': !isOpen }"
                :disabled="!isIdleMode"
                @click="goToBagActionModal"
            />
        </div>
        <div class="c-td">
            <the-btn
                v-text="'Szczegóły'"
                class="btn-sm btn-outline-custom w-100"
                @click="$store.dispatch('openModal', {
                    componentPath: 'drs/stores/bags/BagDetails',
                    args: { bag }
                })"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DEVICE_NAMES } from '@/utils/constants/drs/store-devices.js'
import sealNumber from '@/helpers/seal-number'
import bagsMixin from '@/components/drs/stores/bags/bags.mixin'
import { MODES } from '@/utils/constants/drs/bags'

export default {
    operatorTooltip: 'Dla worków ze statusem OTWARTY pod numerem plomby wyświetla się preferowany operator.<br/>Przy workach ze statusem ZAMKNIĘTY pojawia się operator, którego plombą zamknąłeś (-aś) worek',

    sealNumber,

    mixins: [bagsMixin],

    props: {
        bag: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapGetters('drsBags', [
            'mode',
            'selectedPackages',
            'selectedPackageIds',
            'isPackageSelectable'
        ]),

        referencePackage() {
            return this.selectedPackages[0]
        },

        selectedOperatorId() {
            return this.referencePackage?.preferredOperator.id
        },

        selectedFractionId() {
            return this.referencePackage?.fractionTypeId
        },

        isSelectable() {
            return this.isPackageSelectable(this.bag)
        },

        isIdleMode() {
            return this.mode === MODES.IDLE
        },

        checkboxTooltip() {
            if (this.isIdleMode) {
                // Idle mode tooltip
                return 'Aby zaznaczyć worek, użyj przycisku "Połącz worki" lub "Wydaj worki"'
            }

            if (this.isSelectable) {
                // active checkbox
                return null
            }

            const ref = this.referencePackage

            if (this.mode === MODES.MERGE) {
                // rvm tooltip
                if (this.bag.device_type === DEVICE_NAMES.RVM) {
                    return 'Nie można łączyć worków pochodzących z automatów RVM'
                }

                // different fraction tooltip
                if (ref && this.bag.fractions[0].id !== ref.fractions[0].id) {
                    return 'Łączenie worków jest możliwe jedynie dla tych samych frakcji'
                }
            }

            if (this.mode === MODES.TRANSFER) {
                // different operator tooltip
                if (ref && this.bag.selectedOperator?.id !== ref.selectedOperator?.id) {
                    return 'Wydawanie worków jest możliwe jedynie dla jednego Operatora'
                }
            }

            return null
        }

    },

    methods: {
        ...mapActions('drsBags', ['togglePackageInMode']),
        goToBagActionModal() {
            const componentPath = this.isOpen ? 'drs/stores/bags/CloseBag' : 'drs/stores/bags/EditBag'
            const args = { bag: this.bag }

            this.$store.dispatch('openModal', { componentPath, args })
        }
    }
}
</script>